<template>
  <div class="module-container mars-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div
          class="main-image-container bg-purple rounded d-flex justify-content-center align-items-center"
        >
          <img
            height="25"
            width="25"
            :src="require('../../assets/icons/drugs.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">MARS</h3>
      </div>
      <view-switch :options="viewOptions" v-model="currentView" />
      <b-button
        variant="primary"
        @click="addPrnMedication"
        class="smaller-button button-custom-blue"
        ><i class="fa fa-plus mr-2" aria-hidden="true"></i> Add PRN
        medication</b-button
      >
    </div>
    <mars-list
      ref="marsList"
      v-show="currentView == 'list'"
      :showing="showing && currentView == 'list'"
      :assignedToMeValue="assignedToMe"
      @change-assignedToMe="changeAssignedToMeToggle"
    ></mars-list>
    <mars-scheduler
      ref="marsScheduler"
      v-show="currentView == 'scheduler'"
      :showing="showing && currentView == 'scheduler'"
      :assignedToMeValue="assignedToMe"
      @change-assignedToMe="changeAssignedToMeToggle"
    />
    <mars-add-edit-medication-modal
      v-if="showAddEditMedication"
      v-model="showAddEditMedication"
      @onModify="onModifyAddEditMedication"
      :serviceScheduleId="editMedicationId"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MarsAddEditMedicationModal from "./MarsAddEditMedicationModal";
import MarsList from "./MarsList";
import MarsScheduler from "./MarsScheduler";
import ViewSwitch from "../controls/ViewSwitch.vue";

export default {
  name: "MarsIndex",
  components: {
    MarsAddEditMedicationModal,
    MarsList,
    MarsScheduler,
    ViewSwitch
  },
  props: ["showing"],
  data() {
    return {
      currentView: "scheduler",
      showAddEditMedication: false,
      editMedicationId: null,
      viewOptions: [
        {
          value: "scheduler",
          label: "Scheduler",
          icon: "fas fa-calendar"
        },
        {
          value: "list",
          label: "List",
          icon: "fas fa-list-ul"
        }
      ]
    };
  },
  methods: {
    ...mapActions("layout", ["toggleAssignToMeMarsIndex"]),
    addPrnMedication() {
      this.editMedicationId = null;
      this.showAddEditMedication = true;
    },
    onModifyAddEditMedication() {
      this.showAddEditMedication = false;
      this.$refs.marsList.fetchMars();
      this.$refs.marsScheduler.fetchMars();
    },
    changeAssignedToMeToggle() {
      this.toggleAssignToMeMarsIndex();
    }
  },
  computed: {
    ...mapState("layout", {
      assignedToMe: state => state.assignedToMeMarsIndex
    })
  }
};
</script>

<style scoped>
.view-options {
  min-width: 100px;
}
</style>
